<template>
  <div class="page">
    <div class="section detail">
      <div class="song-name">{{songName}}</div>
      <div class="singer-name">{{singerName}}</div>
      <div class="message">{{message}}</div>
      <div class="like"></div>
    </div>
    <div v-if="!commentList.length" class="comment__add empty">评论</div>
    <div v-if="commentList.length" class="section comment">
      <div class="section__head">
        <div class="comment__title">所有评论</div>
        <div class="comment__add">评论</div>
      </div>
      <div class="comment__list">
        <div class="comment__item">
          <div class="comment__item__hd">
            <img class="avatar" src="">
          </div>
          <div class="comment__item__bd">
            <div class="nickname">荞麦</div>
            <div class="content">我是傻逼我是傻逼我是傻逼</div>
            <div class="like">520 like</div>
          </div>
        </div>
        <div class="comment__item">
          <div class="comment__item__hd">
            <img class="avatar" src="">
          </div>
          <div class="comment__item__bd">
            <div class="nickname">荞麦</div>
            <div class="content">我是傻逼我是傻逼我是傻逼我是傻逼我是傻逼我是傻逼我是傻逼我是傻逼我是傻逼</div>
            <div class="like">520 like</div>
          </div>
        </div>
        <div class="comment__item">
          <div class="comment__item__hd">
            <img class="avatar" src="">
          </div>
          <div class="comment__item__bd">
            <div class="nickname">荞麦</div>
            <div class="content">我是傻逼我是傻逼我是傻逼</div>
            <div class="like">520 like</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CellGroup, Field, Cell, Switch, Icon, Button, Popup, DatetimePicker } from 'vant'
// import api from '@/api'

export default {
  name: 'SongDetail',
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data () {
    return {
      songName: '告白气球',
      singerName: '周杰伦',
      message: '慢慢喜欢你',
      nickname: '蛋挞',
      checked: true,
      date: '今天',
      datetimePickerShow: false,
      currentDate: new Date(),
      commentList: [
        1
      ]
    }
  },
  methods: {
    showPopup() {
      this.datetimePickerShow = true
    },
  },
  created () {
    // this.commentList()
  }
}
</script>

<style lang="less" scoped>
.page {
  // min-height: 100vh;
  // background: #f7f7f7;
}
.section {
  // background: #fff;
  &__head {
    display: flex;
    justify-content: space-between;
    padding: 20px 20px 0;
    font-size: 14px;
    line-height: 1;
  }
}
.detail {
  flex-shrink: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f1f1f1;
  padding: 20px;
  line-height: 1;
  position: relative;
  .song-name {
    font-size: 20px;
    font-weight: bold;
    color: #000;
  }
  .singer-name {
    margin-top: 8px;
    font-size: 14px;
    color: #999;
  }
  .message {
    flex: 1;
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
    position: relative;
    &:before {
      content: '“ ';
      font-size: 20px;
      font-weight: bold;
      color: #999;
    }
    &:after {
      content: ' ”';
      font-size: 20px;
      font-weight: bold;
      color: #999;
    }
  }
}
.comment {
  border-top: 1px solid #f1f1f1;
  // margin-top: 10px;
  // background: none;
  &__title {
    // font-size: 14px;
    // font-weight: bold;
    // color: #666;
  }
  &__add {
    // font-size: 14px;
    color: #409eff;
    &.empty {
      padding: 20px;
      font-size: 14px;
      line-height: 1;
      text-align: center;
    }
  }
  &__list {
  }
  &__item {
    display: flex;
    margin-top: 20px;
    padding: 0 20px;
    line-height: 1;
    &__hd {
      flex-shrink: 0;
    }
    &__bd {
      flex: 1;
      position: relative;
    }
    .avatar {
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }
    .nickname {
      font-size: 13px;
      color: #999;
    }
    .content {
      margin-top: 5px;
      font-size: 14px;
      line-height: 20px;
    }
    .like {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 13px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/songDetail/index.vue